import { useNavigate, useSearchParams } from "react-router-dom";
import { mapRevAud } from "src/components/pages/Summary/ReviewsAndAudits/RevAud.utils";
import RevAudTable from "src/components/pages/Summary/ReviewsAndAudits/RevAudTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { Button } from "src/components/shared/Button/Button";
import { useCheckPerm, useGetApi, useIsOnline } from "src/hooks";
import { ButtonWrapper } from "src/pages/Settings/AccountDetails/AccountDetails.styled";
import { useSelector } from "src/redux/hooks";
import { PageContainer } from "src/styled";

import useGetRevAud from "../../../components/pages/Summary/ReviewsAndAudits/useGetRevAud";

const Reviews = () => {
  const navigate = useNavigate();
  const isOnline = useIsOnline();
  const checkPerm = useCheckPerm();
  const yachtuser = useSelector(state => state.permsSlice.yachtuser);

  const { data, refetch, isLoading } = useGetRevAud(
    yachtuser ? "get-reviews" : "get-reviews-flag",
  );
  return (
    <PageContainer>
      <Breadcrumbs
        customLinks={!yachtuser ? links => links.slice(2) : undefined}
        border={false}>
        <ButtonWrapper>
          {checkPerm("review") && (
            <Button
              onClick={() => navigate("/summary/reviews/create-review")}
              disabled={!isOnline}>
              Create
            </Button>
          )}
        </ButtonWrapper>
      </Breadcrumbs>
      <RevAudTable data={data ?? []} refetch={refetch} loading={isLoading} />
    </PageContainer>
  );
};

export default Reviews;
